import axios from "axios";

function resolveBackendUrl() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;

  if (typeof window !== "undefined") {
    const { hostname } = window.location;
    if (hostname === "staging.spikesports.ca") {
      return "https://api-staging.spikesports.ca";
    }
    if (hostname === "spikesports.ca" || hostname === "www.spikesports.ca") {
      return "https://api.spikesports.ca";
    }
  }

  return "";
}

const BACKEND_URL = resolveBackendUrl();
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
